import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'store/redux/user/selectors';

function loadScript(
  url: string,
  attributes: { id: string },
  onLoadCallback: () => void,
) {
  if (document.getElementById(attributes.id)) {
    return onLoadCallback();
  }

  const s = document.createElement('script');
  s.setAttribute('src', url);

  Object.entries(attributes).forEach(([key, val]: [string, string]) => {
    s.setAttribute(key, val);
  });

  if (onLoadCallback) {
    s.addEventListener('load', onLoadCallback);
  }
  document.body.appendChild(s);
}

export function useIntercom(
  intercomId: string,
  initializeOpen = false,
  isEnabled = true,
) {
  const user = useSelector(selectUser);

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    loadScript(
      `https://widget.intercom.io/widget/${intercomId}`,
      { id: 'icom-snippet' },
      () => {
        const userData = user
          ? {
              user_id: user.userId,
              user_hash: user.webIntercomUserHmac,
            }
          : {};

        if (window.Intercom) {
          window.Intercom('boot', {
            app_id: intercomId,
            ...userData,
          });

          if (initializeOpen) {
            window.Intercom('showMessages');
          }
        }
      },
    );
  }, [intercomId, user, initializeOpen, isEnabled]);
}
